export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="33" height="26" viewBox="0 0 33 26" fill="none">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.10413 25.7357C7.37 26.1019 6.478 25.8036 6.1118 25.0695L0.294175 13.4064C-0.0720201 12.6723 0.226257 11.7803 0.960396 11.4141L21.857 0.990695C22.2302 0.804548 22.6644 0.783844 23.0536 0.933638L31.2946 4.10542C32.0123 4.38164 32.4006 5.15994 32.1895 5.89942L29.7661 14.3907C29.6517 14.7917 29.3739 15.1261 29.0008 15.3123L8.10413 25.7357ZM25.6017 5.79904C26.4867 5.35762 27.5619 5.71717 28.0033 6.6021C28.4447 7.48704 28.0852 8.56226 27.2002 9.00367C26.3153 9.44508 25.2401 9.08554 24.7987 8.2006C24.3572 7.31567 24.7168 6.24045 25.6017 5.79904Z"
                fill="#3F68E0"
            />
        </svg>
    );
}
